<template>
    <div>
        <b-tabs>
            <b-tab active>
                <template slot="title">
                    <h6>Series</h6>
                </template> 
                <template>
                    <series-soporte-data></series-soporte-data>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6>Direcciones</h6>
                </template>
                <template>
                   <direcciones-soporte-data></direcciones-soporte-data>
                </template>
            </b-tab>
        </b-tabs>
        
    </div>
</template>
<script>
import seriesSoporteData from '@/components/seriesSoporte/seriesSoporteData'
import direccionesSoporteData from '@/components/seriesSoporte/direccionesSoporteData'
export default {
  components: { seriesSoporteData, direccionesSoporteData },
    data() {
        return {
        }
    },
}
</script>
<style  scoped>

</style>